<template>
  <section>
    <!-- 注册模块 -->
    <div class="register__container" :style="mainBg">
      <div class="register__wrap">
        <div class="register__main">
          <div class="register__left">
            <p class="register__title-1">{{$t("landingPage.main_title1")}}</p>
            <div class="register__title-2">
              <img src="https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210410112805379.png" alt="">
              <span>{{$t("landingPage.main_title2")}}</span>
            </div>
            <!-- <p class="register__title-3">VDollar.io</p> -->
            <p class="register__title-4">{{$t("landingPage.main_title3")}}</p>
            <p class="download" @click="goDownload">{{$t("landingPage.main_download")}}</p>
          </div>
          <div class="register__right">
            <div class="reigister__wrap">
              <div class="line__item line__parti">
                <div class="code">
                  <img src="@/assets/images/1/flag.png" alt="">
                  <span><i>+</i>86</span>
                  <!-- <input type="text" placeholder="+86"> -->
                </div>
                <input type="text" :placeholder="$t('personal.label.phone')"
                v-model="userValue" class="phone">
              </div>
              <!-- <div class="line-item">
                <input type="text" v-model="passValue" placeholder="密码" />
              </div>
              <div class="line-item">
                <input type="text" v-model="comfirmValue" placeholder="确认密码" />
              </div> -->
              <div class="line-item">
                <input type="text" :placeholder="$t('personal.label.inviteCode')"
                v-model="invitedValue">
              </div>
              <div class="line-item line-btn" @click="goRegister(1)">
                <span>{{$t("login.goRegister")}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="register__foot">
          <p>{{$t("landingPage.main_text1")}}</p>
          <p>{{$t("landingPage.main_text2")}}</p>
        </div>
      </div>
    </div>
    <!-- Never thought  -->
    <div class="never__container">
      <div class="never__wrap">
        <div class="never__title">
          <p class="title__en">Never thought they made money like this!</p>
          <p class="title__zh">{{$t("landingPage.never_title")}}</p>
        </div>
        <div class="never__content-item never__first">
          <div class="never__wrap-left">
            <div class="left__title">
              <img src="@/assets/images/1/icon4_line.png" alt="" />
              <p>{{$t("landingPage.never_item1_title")}}</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item1_text1")}} Fil 25 USD - - -</p>
              <p>{{$t("landingPage.never_item1_text5")}} 200 USD</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item1_text1")}} Fil 25 USD - - -</p>
              <p>{{$t("landingPage.never_item1_text6")}} 200 USD</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item1_text2")}} Fil 25 USD - - -</p>
              <p>{{$t("landingPage.never_item1_text6")}} 200 USD</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item1_text3")}} DOGE 0.002 USD - - -</p>
              <p>{{$t("landingPage.never_item1_text7")}} 200 USD</p>
            </div>
            <div class="left__item hilight">
              <p>{{$t("landingPage.never_item1_text4")}} VD 1 USD - - -</p>
              <p>{{$t("landingPage.never_item1_text8")}}</p>
            </div>
            <div class="left__item foot">
              <p>{{$t("landingPage.never_item1_text9")}}</p>
            </div>
          </div>
          <div class="never__wrap-right">
            <img src="@/assets/images/1/landing_never1.png" alt="" />
          </div>
        </div>
        <div class="never__content-item">
          <div class="never__wrap-right">
            <img src="@/assets/images/1/landing_never2.png" alt="" />
          </div>
          <div class="never__wrap-left">
            <div class="left__title">
              <img src="@/assets/images/1/icon4_line.png" alt="" />
              <p>{{$t("landingPage.never_item2_title")}}</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item2_text1")}}</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item2_text2")}}</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item2_text3")}}</p>
            </div>
            <div class="left__item">
              <p>{{$t("landingPage.never_item2_text4")}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资产递增 -->
    <div class="assets__container">
      <div class="assets__wrap">
        <div class="assets__wrap-left">
          <div class="assets__title">{{$t("landingPage.level_title")}}</div>
          <p class="assets__item">{{$t("landingPage.level_text1")}}</p>
          <p class="assets__item">{{$t("landingPage.level_text2")}}</p>
          <p class="assets__item">{{$t("landingPage.level_text3")}}</p>
          <p class="assets__item">{{$t("landingPage.level_text4")}}</p>
          <p class="assets__item">{{$t("landingPage.level_text5")}}</p>
          <p class="assets__item">{{$t("landingPage.level_text6")}}</p>
          <div class="assets__register" @click="goRegister(2)">
            <span>{{$t("login.goRegister")}}</span>
            <img src="@/assets/images/1/btn_to.png" alt="" />
          </div>
        </div>
        <div class="assets__wrap-right">
          <img src="@/assets/images/1/landing_level.png" alt="" />
        </div>
      </div>
    </div>
    <!-- Representative -->
    <div class="representative__container" :style="representativeBg">
      <div class="representative__wrap">
        <div class="representative__title">
          <p class="title__en">Super Representative Candidate</p>
          <p class="title__zh">{{$t("landingPage.presentive1")}}</p>
          <p class="title__zh-2">
            {{$t("landingPage.presentive2")}}
            <!-- <span>vdollar.io</span> -->
            {{$t("landingPage.presentive3")}}
          </p>
        </div>
        <div class="representative__content">
          <div class="representative__item">
            <img src="@/assets/images/1/logo_1.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_2.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_3.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_4.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_5.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_6.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_7.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_8.png" alt="" />
          </div>
          <div class="representative__item">
            <img src="@/assets/images/1/logo_9.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/landingPage/index';
import 'BlockChain-ui-privatization/PC/common-mixin/landingPage/index.styl';

export default {
  mixins: [mixin],
};
</script>
